import React, { useState } from 'react';
import { FaCreditCard, FaLock } from 'react-icons/fa';
import { loadBalance } from '../../../services/cardService';
import api from '../../../services/api';
import { message } from 'antd';

const CardBalanceLoad = () => {
    const [cardNumber, setCardNumber] = useState('');
    const [identityNumber, setIdentityNumber] = useState('');
    const [phone, setPhone] = useState('');
    const [programType, setProgramType] = useState('Fitness');
    const [amount, setAmount] = useState('');

    const handleLoad = async () => {
        if (!amount) return;
        if (programType === 'Fitness' && (identityNumber.length !== 11 || !/^5\d{9}$/.test(phone.trim()))) {
            message.warning('11 haneli TC kimlik ve 5 ile başlayan 10 haneli telefon numarası zorunludur.');
            return;
        }
        if (programType !== 'Fitness' && !cardNumber) return;

        try {
            const res = await loadBalance({
                cardNumber: programType === 'Fitness' ? null : cardNumber,
                identityNumber: programType === 'Fitness' ? identityNumber : null,
                phone: programType === 'Fitness' ? phone.trim() : null,
                programType,
                amount: parseFloat(amount)
            });
            if (res.data?.isSuccess) {
                const txData = res.data.data;

                // Initiate payment through existing Payment controller.
                const paymentRes = await api.post('/api/payment/initiate-3d', {
                    description: txData.description,
                    amount: txData.amount,
                    currencyCode: 'TRY',
                    installmentsCount: 0,
                    paymentGroup: 'CardTopUp',
                    buyerId: 'guest',
                    callbackUrl: window.location.origin + '/api/payment/callback'
                });

                if (paymentRes.data?.isSuccess) {
                    const formHtml = paymentRes.data.data;
                    const newWindow = window.open('', '_self');
                    newWindow.document.write(formHtml);
                } else {
                    message.error('Odeme baslatilamadi: ' + paymentRes.data?.resultMessage);
                }
            } else {
                message.error(res.data?.resultMessage || 'Islem baslatilamadi.');
            }
        } catch (error) {
            console.error(error);
            message.error('Hata olustu.');
        }
    };

    return (
        <div className="booking-form balance-load-modern">
            <div className="balance-load-header">
                <div className="balance-load-title-wrap">
                    <span className="balance-load-icon">
                        <FaCreditCard />
                    </span>
                    <div>
                        <h4>Bakiye Yukleme</h4>
                        <p>{programType === 'Fitness' ? 'TC ve telefon bilgileriyle' : 'Kart numarasıyla'} yükleme işlemini başlatın.</p>
                    </div>
                </div>
                <span className="balance-load-security">
                    <FaLock />
                    Guvenli odeme
                </span>
            </div>

            <div className="balance-load-fields">
                <div className="form-group">
                    <label>Program</label>
                    <select className="form-input" value={programType} onChange={(e) => setProgramType(e.target.value)}>
                        <option value="Fitness">Fitness</option>
                        <option value="Pool">Havuz</option>
                    </select>
                </div>

                {programType === 'Fitness' ? (
                    <>
                        <div className="form-group">
                            <label>TC Kimlik Numarası</label>
                            <input className="form-input" inputMode="numeric" maxLength={11} value={identityNumber} onChange={(e) => setIdentityNumber(e.target.value.replace(/\D/g, '').slice(0, 11))} placeholder="11 haneli TC kimlik numarası" />
                        </div>
                        <div className="form-group">
                            <label>Telefon Numarası</label>
                            <input className="form-input" type="tel" inputMode="numeric" maxLength={10} value={phone} onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))} placeholder="5XXXXXXXXX" />
                        </div>
                    </>
                ) : (
                    <div className="form-group">
                        <label>Kart Numarası</label>
                        <input className="form-input" value={cardNumber} onChange={(e) => setCardNumber(e.target.value)} placeholder="Kart üzerindeki numara" />
                    </div>
                )}

                <div className="form-group">
                    <label>Yuklenecek Tutar (TL)</label>
                    <input
                        className="form-input"
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="0.00"
                    />
                    <small className="balance-load-helper">Minimum tutar isletme kurallarina gore belirlenir.</small>
                </div>
            </div>

            <button className="submit-button balance-load-submit" onClick={handleLoad}>
                Odemeye Gec
            </button>
        </div>
    );
};

export default CardBalanceLoad;
